import { render } from "./CASIScoreInput.vue?vue&type=template&id=df790db2&scoped=true"
import script from "./CASIScoreInput.vue?vue&type=script&lang=js"
export * from "./CASIScoreInput.vue?vue&type=script&lang=js"

import "./CASIScoreInput.vue?vue&type=style&index=0&id=df790db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df790db2"]])

export default __exports__